module.exports = __webpack_public_path__ + "img/estimated-insurance-required.2cdeda64.png";